import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem, size } from 'polished'

import { getFocusVisibleStyle } from '@Styles/focus'

const HEADER_HEIGHT = rem(72)

export const header = (theme: Theme): SerializedStyles =>
  css({
    alignItems: 'center',
    display: 'flex',
    height: HEADER_HEIGHT,
    padding: theme.spacing('0', 2),
  })

export const headerIconButton = (theme: Theme): SerializedStyles =>
  css({
    '&:focus-visible::before': getFocusVisibleStyle(theme.palette.primary.contrastText, '50%'),
    padding: 0,
  })

export const headerCloseButton = (theme: Theme): SerializedStyles =>
  css({
    ...size(40),
    fill: theme.palette.text.primary,
  })

export const body = (theme: Theme): SerializedStyles =>
  css({
    flex: '1 0 auto',
    maxHeight: `calc(100vh - ${HEADER_HEIGHT} - ${rem(24)})`,
    overflowY: 'auto',
    padding: theme.spacing('0', 2, 2),
  })

export const title = (theme: Theme): SerializedStyles =>
  css({
    marginBottom: theme.spacing(2),
  })
